export class TransactionBatch
{
    id: string;
    name: string;
    created: Date;
    isProcessed: boolean;
    tenantId: string;
}
